<template>
  <section :class="['transfer-design--wrapper', 'content modal-scroll-area', { 'hide': enableSnapShotService && !showExternalViewer }]">
    <p class="transfer-design--description">
      {{ translations.transferDesignModalDescription }}
    </p>
    <div :class="['transfer-design--options-scroll', { 'scroll-activated': isOverMaxLength }]">
      <div class="transfer-design--options">
        <div
          :class="['transfer-design--option', { 'selected': isSelected(modelName) }]"
          v-for="(recipeData, modelName) in recipes"
          :key="modelName"
          @click="onSelect(modelName, recipeData)"
        >
          <external-viewer 
            v-if="enableSnapShotService" 
            :modelName="modelName" 
            :recipeData="recipeData.recipe_v2"
            canvasWidth="500"
            canvasHeight="500"
          ></external-viewer>
          <div v-else
            class="transfer-design--image"
            :style="`background-image: url('${ $store.state.transferDesign.imageUrls[modelName] }')`"
          ></div>
          <div class="transfer-design--content">
            <p class="transfer-design--name">{{ recipeData.displayName }}</p>
            <p class="transfer-design--price"><currency-wrapper :priceRaw="prices[modelName]" /></p>
            <p class="transfer-design--text" v-show="recipeData.isPersonalizationInvalid">{{ translations.transferDesignEmbroideryText }}</p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import currencyWrapper from '@/components/Globals/CurrencyWrapper'
import designContent from '@/mixins/TransferDesign/DesignContent';
import ExternalViewer from '@/components/molecule.external.3dviewer.vue';

export default {
  name: "transferDesignContent",
  data() {
    return {
      showExternalViewer: false
    }
  },
  components: {
    currencyWrapper,
    ExternalViewer
  },
  computed: {
    enableSnapShotService() {
      return this.$store.state.utils.configuration.enableSnapshotService;
    },
  },
  methods: {
    updateFlags() {
      this.showExternalViewer = true;
      this.$emit('updateLoadingData', false);
    }
  },
  mixins: [designContent],
  created() {
    if(this.enableSnapShotService) {
      this.$emit('updateLoadingData', true);
      this.$eventBus.$on('external-3d-viewer-done', this.updateFlags);
    }
  },
  beforeDestroy() {
    this.$eventBus.$off('external-3d-viewer-done');
  }
}
</script>

